import { DeliveryType } from "./IOrder"

export interface IOrderReportOption {
  period: Period
  startDate?: Date
  endDate?: Date
  customerId?: number
  deliveryType?: DeliveryType
  isNotShipped?: boolean
  Page?: number
  PageSize?: number
  OrderBy?: string
  Filter?: string
}

export interface IOrderReport {
  fuelTypeName: string
  depots: IDepotReport[]
}

export interface IDepotReport {
  depotId: number
  depotName: string
  orderSum: number
  orderAmount: number
}

export enum Period {
  Day,
  Week,
  Month,
  Quarter,
  Year
}

export const ORDER_REPORT_KEY = "ORDER_REPORT_KEY"
